import React from "react";
import "../../css/loading.scss";

const Loading = () => {
  return (
    <div className="loading-overlay">
      <div className="heart-loader">
        <div className="heart-glow"></div>
        <div className="heart-core"></div>
      </div>
      <p className="loading-text">Processing your donation…</p>
    </div>
  );
};

export default Loading;
